import { useCallback, useState } from 'react';
import { GSC_CONNECTION_METHOD, type GscConnectionMethod, useGscConnectionActions } from '../model';
import { GscConnectionModal } from './GscConnectionModal';

export const useGscConnectionDialog = () => {
    const actions = useGscConnectionActions();
    const { connectAutomatically, isSitePublished } = actions;
    const [initialMethod, setInitialMethod] = useState<GscConnectionMethod>(GSC_CONNECTION_METHOD.AUTOMATIC);
    const [isOpen, setIsOpen] = useState(false);

    const close = useCallback(() => setIsOpen(false), []);
    const openConnect = useCallback(() => {
        if (!isSitePublished) {
            connectAutomatically();

            return;
        }

        setInitialMethod(GSC_CONNECTION_METHOD.AUTOMATIC);
        setIsOpen(true);
    }, [connectAutomatically, isSitePublished]);
    const openEdit = useCallback(() => {
        setInitialMethod(GSC_CONNECTION_METHOD.VERIFICATION_CODE);
        setIsOpen(true);
    }, []);

    return {
        ...actions,
        close,
        isOpen,
        node: (
            <GscConnectionModal
                initialMethod={initialMethod}
                isOpen={isOpen}
                onAutomaticConnect={connectAutomatically}
                onClose={close}
                onVerificationCodeSubmit={actions.saveVerificationCode}
                verificationCode={actions.verificationCode}
            />
        ),
        openConnect,
        openEdit,
    };
};
